import { createContext } from "react";

export const ICFContext = createContext(null);
